'use client';

import { c as _c } from "react/compiler-runtime";
import { Check, Copy } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { useCopyToClipboard } from '../../hooks/use-copy-to-clipboard';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
export const adornmentBaseClassName = 'relative shrink-0 cursor-pointer text-muted-foreground transition-[opacity,color] duration-150 hover:text-foreground focus-visible:opacity-100';
export const fieldRevealClassName = 'group-hover/field:opacity-100 md:group-hover/field:opacity-100 group-focus-within/field:opacity-100 md:opacity-0';
export const adornmentClassName = `${adornmentBaseClassName} ${fieldRevealClassName}`;
const iconClassName = 'absolute inset-0 size-full transition-transform duration-200';
export const CopyButton = t0 => {
  const $ = _c(30);
  const {
    className,
    revealClassName: t1,
    tooltip,
    value
  } = t0;
  const revealClassName = t1 === undefined ? fieldRevealClassName : t1;
  const {
    copied,
    copy
  } = useCopyToClipboard();
  const t2 = copied ? "Copied" : tooltip ?? "Copy";
  const t3 = copied && "opacity-100 md:opacity-100";
  let t4;
  if ($[0] !== className || $[1] !== revealClassName || $[2] !== t3) {
    t4 = cn("relative inline-flex size-5", adornmentBaseClassName, revealClassName, t3, className);
    $[0] = className;
    $[1] = revealClassName;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] !== copy || $[5] !== value) {
    t5 = event => {
      event.preventDefault();
      copy(value);
    };
    t6 = event_0 => {
      if (event_0.key !== "Enter" && event_0.key !== " ") {
        return;
      }
      event_0.preventDefault();
      copy(value);
    };
    $[4] = copy;
    $[5] = value;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  const t7 = copied ? "invisible scale-75" : "visible scale-100";
  let t8;
  if ($[8] !== t7) {
    t8 = cn(iconClassName, t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <Copy className={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = copied ? "visible scale-100" : "invisible scale-75";
  let t11;
  if ($[12] !== t10) {
    t11 = cn(iconClassName, t10);
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <Check className={t11} />;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t2 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t9) {
    t13 = <span aria-label={t2} className={t4} onClick={t5} onKeyDown={t6} role="button" tabIndex={0}>{t9}{t12}</span>;
    $[16] = t12;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const button = t13;
  if (!tooltip) {
    return button;
  }
  let t14;
  if ($[23] !== button) {
    t14 = <TooltipTrigger render={button} data-sentry-element="TooltipTrigger" data-sentry-source-file="copy-button.tsx" />;
    $[23] = button;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = copied ? "Copied" : tooltip;
  let t16;
  if ($[25] !== t15) {
    t16 = <TooltipContent data-sentry-element="TooltipContent" data-sentry-source-file="copy-button.tsx">{t15}</TooltipContent>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <Tooltip data-sentry-element="Tooltip" data-sentry-component="CopyButton" data-sentry-source-file="copy-button.tsx">{t14}{t16}</Tooltip>;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};